import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';

export default function EditEtude({ id, idCv }) {
    const [etude, setEtude] = useState({});
    const [ecole, setEcole] = useState('');
    const [dateEtude, setDateEtude] = useState('');
    const [dateFinEcole, setDateFinEcole] = useState('');
    const [descEtude, setDescEtude] = useState('');
    const [showConfirm, setShowConfirm] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchEtude = async () => {
            try {
                const resp = await axios.get(`diplomes/${id}`);
                if (resp.status === 200) {
                    const { ecole, datecole, datefinecole, descriptionecole } = resp.data;
                    setEcole(ecole);
                    setDateEtude(datecole);
                    setDateFinEcole(datefinecole);
                    setDescEtude(descriptionecole);
                }
            } catch (error) {
                console.error(error);
                NotificationManager.error('Erreur lors de la récupération des données', 'Erreur', 4000);
            }
        };

        fetchEtude();
    }, [id]);

    const editEtude = async () => {
        const data = new FormData();
        if (ecole) data.append('ecole', ecole);
        if (dateEtude) data.append('datecole', dateEtude);
        if (descEtude) data.append('descriptionecole', descEtude);
        if (dateFinEcole) data.append('datefinecole', dateFinEcole);

        try {
            if (data.has('ecole') || data.has('datecole') || data.has('descriptionecole') || data.has('datefinecole')) {
                const resp = await axios.put(`diplomes/${id}`, data);
                if (resp.status === 200) {
                    NotificationManager.success('Modifications enregistrées avec succès', 'Succès', 4000);
                }
            } else {
                NotificationManager.warning('Aucune modification enregistrée', 'Avertissement', 4000);
            }
        } catch (error) {
            console.error(error);
            NotificationManager.error('Erreur lors de la modification', 'Erreur', 4000);
        }
    };

    const deleteEtude = async () => {
        try {
            const resp = await axios.delete(`diplomes/${id}`);
            if (resp.status === 204) {
                NotificationManager.success('Étude ou formation supprimée avec succès', 'Succès', 4000);
                // setTimeout(() => navigate('/cv'), 3000);
                // navigate(`/editCv/${idCv}`);
                navigate(`/cv/${idCv}`);
            }
        } catch (error) {
            console.error(error);
            NotificationManager.error('Erreur lors de la suppression', 'Erreur', 4000);
        }
    };

    const datable = Array.from({ length: 51 }, (_, i) => (1990 + i).toString());

    return (
        <>
            <form>
                <div className="row mb-3">
                    <div className="col-sm-3">
                        <h6 className="mb-0">Institution ou école</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                        <input
                            type="text"
                            className="form-control"
                            value={ecole}
                            onChange={(e) => setEcole(e.target.value)}
                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-3">
                        <h6 className="mb-0">Date d'étude</h6>
                    </div>
                    <div className="col-sm-5 text-secondary">
                        <select
                            className="form-control"
                            value={dateEtude}
                            onChange={(e) => setDateEtude(e.target.value)}
                        >
                            <option value="">Sélectionner une date de début</option>
                            {datable.map((date) => (
                                <option key={date} value={date}>{date}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-sm-4 text-secondary">
                        <select
                            className="form-control"
                            value={dateFinEcole}
                            onChange={(e) => setDateFinEcole(e.target.value)}
                        >
                            <option value="">Sélectionner une date de fin</option>
                            {datable.map((date) => (
                                <option key={date} value={date}>{date}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-sm-3">
                        <h6 className="mb-0">Description</h6>
                    </div>
                    <div className="col-sm-9 text-secondary">
                        <textarea
                            className="form-control"
                            value={descEtude}
                            rows={4}
                            onChange={(e) => setDescEtude(e.target.value)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-9 text-secondary">
                        <div className="btn-group" role="group" aria-label="Actions">
                            <button type="button" onClick={editEtude} className="btn btn-primary">
                                <i className="bi bi-bookmark-fill"></i>&nbsp;
                                Enregistrer les modifications
                            </button>
                            <button type="button" onClick={() => setShowConfirm(true)} className="btn btn-danger">
                                <i className="bi bi-trash"></i>&nbsp;
                                Supprimer
                            </button>
                        </div>
                    </div>
                </div>
            </form>

            {/* Confirmation Modal */}
            <Modal show={showConfirm} onHide={() => setShowConfirm(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirmer la suppression</Modal.Title>
                </Modal.Header>
                <Modal.Body>Êtes-vous sûr de vouloir supprimer cette étude ou formation ?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowConfirm(false)}>
                        Annuler
                    </Button>
                    <Button variant="danger" onClick={deleteEtude}>
                        Supprimer
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
